export default __webpack_public_path__ + "static/media/medicine-box.c3fdbc97.svg";